import { useState } from "react";

const Select = (props) => {
  const [data] = useState(props.data);
  const [selectedData, updateSelectedData] = useState("");
  function handleChange(event) {
    updateSelectedData(event.target.value);
    if (props.onSelectChange) props.onSelectChange(selectedData);
  }

  let options = data.map(data => (
    <option key={data.id} value={data.id}>
      {data.name}
    </option>
  ));
  return (
    <select
      className={`select select-bordered border-inputBorder w-full max-w-xs focus:ring-0 focus:outline-none focus:border-red-600 ${props.className}`}
      onChange={handleChange}
      {...props}
    >
      <option className="text-gray-400" disabled="disabled" selected="selected">{props.placeholder}</option> 
      {options}
    </select>
  );
}

Select.defaultProps = {
  data: []
}

export { Select };